// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper--nYU","image":"Empty_image--ILA","text":"Empty_text--OAO","infoText":"Empty_infoText--saq"};